import LogRocket from 'logrocket';
if (process.env.REACT_APP_RELEASE_VERSION) {
  LogRocket.init('gcoxl1/virtual-engineer-dashboard', {
    mergeIframes: true,
    release: `${process.env.REACT_APP_RELEASE_VERSION}`,
  });
}
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faBook,
  faBriefcase,
  faCaretDown,
  faCaretRight,
  faCartShopping,
  faChevronDown,
  faCircleExclamation,
  faFile,
  faMagnifyingGlass,
  faPen,
  faPlus,
  faRss,
  faTags,
  faTrashCan,
  faUser,
  faXmark,
  faCircleLeft,
  faGears,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { faTwitter, faFacebookF, faYoutube, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

import { setAxiosConfig } from './config/AxiosConfig';
import { StyledEngineProvider } from '@mui/material/styles';

import * as i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { GenericLoadingScreen } from './components/GenericLoadingScreen/GenericLoadingScreen';
import * as wjcCore from '@grapecity/wijmo';
wjcCore.setLicenseKey(
  'virtualengineertest.parker.com|localvedashboard.parker.com|virtualengineer.parker.com|virtualengineerpreview.parker.com|virtualengineerdev.parker.com|virtualengineerdev.us.parker.corp|localhost,541727535252332#B0HbgVHdylmdiojIz5GRiwiIjJXQuVGcPJiOiEmTDJCLiIzMzITNyUzM5cjM7EDN5IiOiQWSiwSfdtlOicGbmJCLiIjdzIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPntSMxY7NzUldzokYBhFOSNHOahVUuZjMw4UQ92mct54S4lmQ6kGOxcnYOJHSEFnd9FHMKFDMwUHUD5EexolQBJmR8ZncPJ4aY94VEBFaOxmTjRHaWlVR7w6ZmlTbGdnWxR4V746QrRzQNVDRv3UOiNzK6BVS5ZWOnpmTQR5RKZUMJp7c7JlNxdDR0N5d5YnY0djT92kcwAlaKNHapFnQzV7SjF7QWh5ZYR6MhRzNLZVOKV4UVFTYzMmSo3yRkN7YKZ6QvRzanlnTzI7VHNGWoZGZzQEcUVTQUpUMSxmQy5EarUnSCFmS63EWENlRWJTYLhTS8QGMDdlaWR7cRVVWllFSJB5ZGRHZIN6N8UTYvNDc62GVKtmWzlTR8F7V8gWeNZ7SjZUcWJkYEB7RH3yK6JmZFRVZLJjT4QGcMhWasdVQhp6NwoWTSdzL8ATesZ6V4IkYZJTQiojITJCLiETN6kDN4M4NiojIIJCL7kTN9YDN4cDO0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsISMxUDN5ADIwITOwMjMwIjI0ICdyNkIsICdz3GasF6YvxGLwJ7bj9icltmchBnLzVnL6VGZyVWZul6ZuVGbhVHdylmds46bj9icltmchBnL6VGZyVWZul6ZuVGbhVHdylmds46bj9icltmchBnL7VWa6VmcwJXZl9Wan9WZsFWd4JXa6xSbvNmLyV6ayFGcuIXZl9Wan9WZsFWd4JXa6xSbvNmLyV6ayFGcuQmch3mYoNXYkVmdsF6YvxGLt36YuIXZrJXYw9CdzVGdyVWZulUZ5V',
);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['cookie'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}/{{ns}}.json',
    },
  });

library.add(
  faMagnifyingGlass,
  faBars,
  faPlus,
  faCaretRight,
  faCaretDown,
  faFile,
  faXmark,
  faCircleExclamation,
  faTrashCan,
  faPen,
  faCircleCheck,
  faTags,
  faCartShopping,
  faChevronDown,
  faUser,
  faRss,
  faTwitter,
  faFacebookF,
  faYoutube,
  faLinkedinIn,
  faInstagram,
  faBook,
  faBriefcase,
  faCircleLeft,
  faGears,
  faUserPlus,
);

setAxiosConfig();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StyledEngineProvider injectFirst>
    <Suspense fallback={<GenericLoadingScreen />}>
      <App />
    </Suspense>
  </StyledEngineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
